"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isExperiment(object) {
    return checkExperiment(object).fulfilled;
}
exports.isExperiment = isExperiment;
function checkExperiment(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("id"), Check_1.hasChoice("state", ["pending", "running", "paused", "stopped"]), Check_1.hasArray("variants", Check_1.isAny())).withOptions(options).explain();
}
exports.checkExperiment = checkExperiment;
//# sourceMappingURL=Experiment.js.map